module.exports = __webpack_public_path__ + "img/kitkitlogo_sw.40d396ee.png";